import axiosInstance from "../config/API";

const API_ENDPOINT = "/staff.php";

// Fetch all staff
export const fetchStaffApi = async (searchText = "") => {
  const payload = {
    search_text: searchText,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("fetch staff:", response.data.body.Staff);
  return response.data.body.Staff || [];
};

// Generate staff_no based on name
export const generateStaffNoApi = async (name) => {
  const payload = {
    generate_staff_no: true,
    name,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("generate staff_no:", response.data);
  return response.data.body.staff_no || "";
};

// Add a new staff
export const addStaffApi = async (staffData) => {
  const payload = {
    staff_name: staffData.staff_name,
    staff_no: staffData.staff_no,
    mobile_number: staffData.mobile_number,
    password: staffData.password,
    current_user_id: staffData.current_user_id,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("add staff:", response.data);
  return response.data;
};

// Update a staff
export const updateStaffApi = async (staffData) => {
  const payload = {
    staff_name: staffData.staff_name,
    staff_no: staffData.staff_no,
    mobile_number: staffData.mobile_number,
    password: staffData.password,
    current_user_id: staffData.current_user_id,
    edit_staff_id: staffData.staff_id,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("update staff:", response.data);
  return response.data;
};

// Delete a staff
export const deleteStaffApi = async (staffId, currentUserId) => {
  const payload = {
    delete_staff_id: staffId,
    current_user_id: currentUserId,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("delete staff:", response.data);
  return response.data;
};
